import type { TimeEntry, TimeLogEvent } from "@pentacode/core";

/**
 * Returns the time log events that belong to one of the given time entries, matched by `timeEntryId`.
 */
export function filterTimeLogEventsForEntries<T extends Pick<TimeLogEvent, "timeEntryId">>(
    events: readonly T[],
    entries: readonly Pick<TimeEntry, "id">[]
): T[] {
    const entryIds = new Set(entries.map((entry) => entry.id));
    return events.filter((event) => event.timeEntryId != null && entryIds.has(event.timeEntryId));
}
